/**
 * Copyright (c) 2018, salesforce.com, inc.
 * All rights reserved.
 * Licensed under the BSD 3-Clause license.
 * For full license text, see LICENSE.txt file in the repo root or
 * https://opensource.org/licenses/BSD-3-Clause
 */
import React from 'react';
import PropTypes from 'prop-types';
import LandingPageSpinner from '../../components/Spinners/LandingPageSpinner';
import StatusGridView from './components/StatusGridView';
import styled from 'styled-components';
import _ from 'lodash'

const Wrapper = styled.div`
  display: flex;
  min-height: 101px;
  height: 100%;
  width:100%;
  justify-content: center;
  align-items: center;

`
const Header = styled.p`
  height: 15px;
  font-family: 'Salesforce Sans';
  font-size: 12px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.25;
  letter-spacing: normal;
  color: #54698d;
`

class RecentInstanceList extends React.Component {

  static propTypes = {
    requests: PropTypes.shape({
      instancePreview: PropTypes.object,
    }),
  };

  constructor() {
    super();
  }
  filterInstancesList(instanceGroups) {
    const mostVisitedInstance = this.props.recentInstance
    if (!instanceGroups || !_.isArray(instanceGroups)) return [];
    return instanceGroups.filter((i) => {
      let bool = i.isActive;
      for (let index = 0; index < mostVisitedInstance.length; index++) {
        const element = mostVisitedInstance[index];
        if (element.key === i.key) {
          i.order = index;
          return bool;
        }
      }
      return false;
    });
  }
  render() {
    const { instancePreview } = this.props.requests;
    const { recentInstance } = this.props.recentInstance;
    if (!instancePreview.isCompleted) {
      return (
        <LandingPageSpinner/>
      );
    }
    const mostVisitedInstance = this.props.recentInstance
    const filteredInstancePreview = this
      .filterInstancesList(instancePreview.value)
    
    const orderedInstanceList = _.chain(filteredInstancePreview).sortBy("order").reverse().value()
    return (
      <div>
        {mostVisitedInstance.length > 0 && <StatusGridView
          instanceGroups={orderedInstanceList}
        />
        }
        {
          mostVisitedInstance.length <= 0 &&
          <Wrapper>
            <Header>No recent instances</Header>
          </Wrapper>
        }
      
      </div>
    );
  }
}
export default RecentInstanceList;
